import { render } from "./my-vehicle-component.vue?vue&type=template&id=2235009b&scoped=true"
import script from "./my-vehicle-component.vue?vue&type=script&lang=js"
export * from "./my-vehicle-component.vue?vue&type=script&lang=js"

import "./my-vehicle-component.vue?vue&type=style&index=0&id=2235009b&scoped=true&lang=css"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2235009b"]])

export default __exports__